import Layout from '@/layout'
export default [
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '/redirect/:path(.*)',
                component: () => import('@/views/redirect/index.vue')
            }
        ]
    },
    {
        path: '/login',
        component: () => import('@/views/login'),
        hidden: true
    },
    {
        path: '/register',
        component: () => import('@/views/register'),
        hidden: true
    },
    {
        path: "/:pathMatch(.*)*",
        component: () => import('@/views/error/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () => import('@/views/error/401'),
        hidden: true
    },
    {
        path: '',
        component: Layout,
        redirect: '/work/index',
        hidden: true,
        // children: [
        //     {
        //         path: '/index',
        //         component: () => import('@/views/index'),
        //         name: 'Index',
        //         meta: { title: '首页', i18n: 'menu.home', icon: 'dashboard', affix: true, permissions: ["afsfds:fsdfsd"] }
        //     }
        // ]
    },
    {
        path: '/user',
        component: Layout,
        hidden: true,
        redirect: 'noredirect',
        children: [
            {
                path: 'profile',
                component: () => import('@/views/system/user/profile/index'),
                name: 'Profile',
                meta: { title: '个人中心', icon: 'user' }
            }
        ]
    },
    // 28181 播放器路由
    {
        path: '/play/wasm/:url',
        name: 'wasmPlayer',
        hidden: true,
        component: () => import('@/views/camera/common/jessibuca.vue')
    },
    {
        path: '/play/rtc/:url',
        name: 'rtcPlayer',
        component: () => import('@/views/camera/common/rtcPlayer.vue')
    },
]